import { Injectable } from '@angular/core';

@Injectable()
export class ProjectConstants {
    private appCode:        string;
    private clientId:       string;
    private countlyKey?:    string;
    private countlyUrl?:    string;
    protected apiBasePath:    string;
    protected apiOrg:         string;
    protected apiEnv:         string;

    constructor() {
        this.appCode        = window[ 'APP_CODE' ];
        this.clientId       = window[ 'CLIENT_ID' ];
        this.apiBasePath    = window[ 'API_HOST' ];
        this.apiOrg         = window[ 'API_ORG' ];
        this.apiEnv         = window[ 'API_ENV' ];
    }


    // ====================================================================================================================
    // Getters
    // ====================================================================================================================

    public getAppCode(): string {
        return this.appCode;
    }

    public getClientId(): string {
        return this.clientId;
    }

    public getApiBasePath(): string {
        return this.apiBasePath;
    }

    public getApiOrg(): string {
        return this.apiOrg;
    }

    public getApiEnv(): string {
        return this.apiEnv;
    }
}
